var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinked = function SvgLinked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.1rem",
    height: "1.1rem",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12a5.966 5.966 0 0 0 5.388-3.357.462.462 0 0 0-.829-.407A5.049 5.049 0 0 1 6 11.076 5.083 5.083 0 0 1 .923 6C.923 3.2 3.201.923 6 .923c2.8 0 5.077 2.278 5.077 5.077A.462.462 0 0 0 12 6c0-3.308-2.692-6-6-6S0 2.692 0 6s2.692 6 6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.986 6.308a.462.462 0 0 0-.462-.462H2.986a.462.462 0 0 0 0 .923h5.538a.462.462 0 0 0 .462-.461zm-6-1.909h3.692a.462.462 0 0 0 0-.923H2.986a.462.462 0 1 0 0 .923zm0 3.817a.462.462 0 0 0 0 .923h2.461a.462.462 0 1 0 0-.923H2.986zm4.797-4.278a.615.615 0 1 0 1.231 0 .615.615 0 0 0-1.23 0z"
  }))));
};
export default SvgLinked;